import { render, staticRenderFns } from "./route_generate.vue?vue&type=template&id=4f83f5c5&scoped=true"
import script from "./route_generate.vue?vue&type=script&lang=js"
export * from "./route_generate.vue?vue&type=script&lang=js"
import style0 from "./route_generate.vue?vue&type=style&index=0&id=4f83f5c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f83f5c5",
  null
  
)

export default component.exports